




























import {PropType, defineComponent} from '@vue/composition-api'
import { IActivity, ActionButtonView } from "@/apps/MyStudyChoiceActivitiesWidget/models/activities-viewmodel"
import { useGetters } from "vuex-composition-helpers"
import OnlineOfflineActionsMolecule from "../Molecules/OnlineOfflineActionsMolecule.vue"

export default defineComponent({
    name: "ActivityButtonOrganism",
    components: {OnlineOfflineActionsMolecule},
    props: {
        activity: {
            type: Object as PropType<IActivity>,
            required: true
        },
        interactive: {
            type: Boolean,
            required: false,
            default: true
        },
        actionButtonView: {
            type: String,
            required: true,
            default: ActionButtonView.SMALL,
            validator: (value: ActionButtonView) => {
                return Object.values(ActionButtonView).includes(value);
            }

        }
    },
    setup: () => {
        const {getConfig} = useGetters(['getConfig'])

        return {
            getConfig,
            ActionButtonView
        }
    }
})
